import type { Action } from 'vuex'
import type { State } from './state'

import actionTypes from './actionTypes'

const actions: { [actionType: string]: Action<State, any> } = {
    [actionTypes.SET_PRODUCT_ADD_SUCCESS]: ({ commit }, status: boolean): void => {
        commit(actionTypes.SET_PRODUCT_ADD_SUCCESS, status)
    },
}

export default actions
